import { create } from 'zustand';

/**
 * Mini Prixia (X1, decisión 24): el cuadro «Esto es parte del plan completo» de toda
 * la app, uno solo. Lo abren el menú (una entrada con candado) y una dirección que la
 * prueba no incluye; se dibuja en el marco (`DialogoDelPlanCompletoGlobal`), encima
 * de la pantalla actual.
 */
interface PlanCompletoState {
  abierto: boolean;
  abrir: () => void;
  cerrar: () => void;
}

export const usePlanCompleto = create<PlanCompletoState>()((set) => ({
  abierto: false,
  abrir: () => set({ abierto: true }),
  cerrar: () => set({ abierto: false }),
}));
